var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFoto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.14847 3.95154H2.2369C2.22177 3.08785 2.53383 2.87771 3.46101 2.87771H4.1435C5.07069 2.87771 5.35985 3.07646 5.3676 3.95154H6.20359C6.20359 2.23845 6.81713 0.774899 8.86299 0.774899H11.0997C13.1456 0.774899 13.7591 2.23859 13.7591 3.95154H18.8146C19.2261 3.95154 19.5628 4.28864 19.5628 4.69993V15.7146C19.5628 16.1261 19.2261 16.4628 18.8146 16.4628H1.1485C0.736939 16.4628 0.400391 16.1262 0.400391 15.7146V4.69993C0.400257 4.28822 0.736953 3.95154 1.1485 3.95154H1.14847ZM9.9911 7.09578C8.27468 7.09578 6.88327 8.43734 6.88327 10.0922C6.88327 11.747 8.27465 13.0883 9.9911 13.0883C11.7075 13.0883 13.0992 11.747 13.0992 10.0922C13.0992 8.43748 11.7075 7.09578 9.9911 7.09578ZM15.4487 5.02804C14.4479 5.02804 14.4481 6.6514 15.4487 6.6514H17.6984C18.699 6.6514 18.6992 5.02804 17.6984 5.02804H15.4487ZM9.99144 5.19867C7.2854 5.19867 5.09167 7.39227 5.09167 10.0981C5.09167 12.804 7.28527 14.9975 9.99144 14.9975C12.6973 14.9975 14.8909 12.804 14.8909 10.0981C14.8909 7.39206 12.6974 5.19867 9.99144 5.19867Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoto);
export default __webpack_public_path__ + "static/media/foto.ee41607b2c0ad9c2513bee4bc3c94fc3.svg";
export { ForwardRef as ReactComponent };